<app-page-header title="Edit Provider"></app-page-header>
<div class="row">
    <div class="col-lg-6">
        <div class="card">
            <div class="card-header" *ngIf="property_provider_model.id">Edit Provider</div>
            <div class="card-header" *ngIf="!property_provider_model.id">Create Provider</div>
            <div class="card-body">
                <form [formGroup]="form">
                    <nexus-row control_id="provider-input" row_label="Provider">{{ property_provider_model.provider.name }}
                    </nexus-row>                    
                    <nexus-row control_id="provider-input" row_label="Category">{{ property_provider_category_model.provider_category.name }}
                    </nexus-row>
                    <nexus-form-row control_id="variance-threshold-input" row_label="Variance Threshold">
                        <kendo-numerictextbox class="form-control" id="variance-threshold-input" formControlName="variance_threshold" format="p">
                        </kendo-numerictextbox>
                    </nexus-form-row>
                    <nexus-form-row control_id="minimum-variance-input" row_label="Minimum Variance Amount">
                        <kendo-numerictextbox class="form-control" id="minimum-variance-input" formControlName="minimum_variance" format="c">
                        </kendo-numerictextbox>
                    </nexus-form-row>
                    <nexus-form-row control_id="minimum-vacant-amount-input" row_label="Minimum Vacant Amount">
                        <kendo-numerictextbox class="form-control" id="minimum-vacant-amount-input" formControlName="minimum_vacant_amount" format="c">
                        </kendo-numerictextbox>
                    </nexus-form-row>
                    <nexus-form-row control_id="floorplan-variance-threshold-input" row_label="Floorplan Variance Threshold">
                        <kendo-numerictextbox class="form-control" id="floorplan-variance-threshold-input" formControlName="floorplan_variance_threshold" format="p">
                        </kendo-numerictextbox>
                    </nexus-form-row>
                    <nexus-form-row control_id="floorplan-minimum-variance-input" row_label="Floorplan Minimum Variance">
                        <kendo-numerictextbox class="form-control" id="floorplan-minimum-variance-input" formControlName="floorplan_minimum_variance" format="c">
                        </kendo-numerictextbox>
                    </nexus-form-row>
                    <nexus-form-row>                    
                        <button kendoButton [icon]="'check'" (click)="submit()" [primary]="true">Submit</button>
                    </nexus-form-row>
                </form>
                <nexus-form-result [model]="form_result"></nexus-form-result>
            </div>
        </div>
    </div>
</div>
<p class="mt-3">
    <a [routerLink]="['/billing','providers']">Back</a>
</p>